module.exports = __webpack_public_path__ + "img/reset.9bf880f8.svg";